import { Loader2 } from "lucide-react";

export function LoadingScreen() {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-primary-100">
      <Loader2 className="h-12 w-12 animate-spin text-blue-brand" />
    </div>
  );
}
